import { queryOptions } from "@tanstack/react-query";
import { apiFetch } from "@/shared/api";

/** Per-stand UI feature flags resolved from backend env. Fetched once and
 *  cached for the session — flags don't change at runtime. */
export interface Features {
  networkFolder: boolean;
}

export function featuresQueryOptions() {
  return queryOptions({
    queryKey: ["features"],
    queryFn: async (): Promise<Features> => {
      try {
        const r = await apiFetch("/api/features", undefined, { crossSpace: true });
        if (!r.ok) return { networkFolder: false };
        return (await r.json()) as Features;
      } catch {
        return { networkFolder: false };
      }
    },
    staleTime: Infinity,
  });
}
